import actionTypes from './../constants/actionTypes';

const initialState = {
    userInfo: {},
    listing: {},
    userDetails: {},
};

export const userReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.USER.LOGIN: {
                return {
                    ...state,
                    userInfo: payload
                }
            }
            case actionTypes.USER.USER_LIST: {
                return {
                    ...state,
                    listing: payload
                }
            }
            case actionTypes.USER.USER_DETAILS_SUCCESS: {
                return {
                    ...state,
                    userDetails: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default userReducer;
